import { createAction, props } from '@ngrx/store';

export const atualizarStatusConexao = createAction(
  '[Status Conexao] Atualizar Status da Conexão',
  props<{ conectado: boolean }>()
);